import { useState } from 'react';
import DocToHtmlFormPreview from '../components/DocToHtmlFormPreview';
import type { Template } from '../api/endpoints/fetchTemplates';

interface DOCFormPreviewProps {
  template: Template;
  onClose?: () => void;
  onInfo?: () => void;
  isInfoPanelOpen?: boolean;
  hideCloseButton?: boolean;
  onSaved?: (fileId: string) => void;
}

export function DocToHtmlPreview({template, onClose, onInfo, isInfoPanelOpen, hideCloseButton, onSaved }: DOCFormPreviewProps) {

  // // Mock template for demo purposes
  // const mockTemplate: Template = {
  //   id: 'doc-to-html-demo',
  //   fileTitle: 'Document to HTML Form',
  //   fileName: 'doc-schema',
  //   fileId: 'doc-schema-001',
  //   htmlFileId: { id: 'html-001', name: 'html' },
  //   userEmail: 'demo@example.com',
  //   createdAt: new Date().toISOString(),
  //   updatedAt: new Date().toISOString(),
  //   isPublished: false,
  //   pdfType: 'CUSTOM_FORM',
  //   isAcroFile: false,
  //   memberId: undefined,
  // };

  return (
    <DocToHtmlFormPreview
      template={template}
      onClose={() => onClose && onClose()}
      onSaved={() => {}}
      onInfo={() => onInfo && onInfo()}
      isInfoPanelOpen={isInfoPanelOpen || false}
    />
  );
}

export default DocToHtmlPreview;
